package com.essntl.uikit.theme

import androidx.compose.ui.graphics.Color

class EsColorScheme(
    // Background
    val bgPrimary: Color,
    val bgSecondary: Color,
    val bgSecondaryHover: Color,
    val bgContrast: Color,
    val bgWarning: Color,
    val bgSuccess: Color,
    val bgError: Color,
    val bgDisable: Color,
    val bgTable: Color,
    val bgTableHover: Color,
    val bgTableActive: Color,

    // Borders
    val borderPrimary: Color,
    val borderSecondary: Color,
    val borderDisabled: Color,
    val borderFocus: Color,
    val borderWarning: Color,
    val borderSuccess: Color,
    val borderError: Color,
    val borderAccent: Color,

    // Text
    val textPrimary: Color,
    val textSecondary: Color,
    val textTertiary: Color,
    val textDisabled: Color,
    val textContrast: Color,
    val textWarning: Color,
    val textSuccess: Color,
    val textError: Color,
    val textAccent: Color,

    // Icons
    val iconPrimary: Color,
    val iconSecondary: Color,
    val iconDisabled: Color,
    val iconContrast: Color,
    val iconWarning: Color,
    val iconSuccess: Color,
    val iconError: Color,
    val iconAccent: Color,

    // Controls
    val primary: Color,
    val primaryHover: Color,
    val primaryPressed: Color,
    val primaryDisabled: Color,

    val tinted: Color,
    val tintedHover: Color,
    val tintedPressed: Color,
    val tintedDisabled: Color,

    val secondary: Color,
    val secondaryHover: Color,
    val secondaryPressed: Color,
    val secondaryDisabled: Color,

    val ghost: Color,
    val ghostHover: Color,
    val ghostPressed: Color,

    val destructive: Color,
    val destructiveHover: Color,
    val destructivePressed: Color,
) {
    class Brand(
        val primary: Color,
    )
}